import { type LngLat, Map as MapLibreMap, Marker, NavigationControl } from 'maplibre-gl';
import { useOwnWorker, zoomHelp } from './maplibre-worker.ts';

const GERMANY: [number, number] = [10.45, 51.16];
const COORDINATES = /(-?\d{1,2}\.\d+)\s*[,;/\s]\s*(-?\d{1,3}\.\d+)/;
const CLOSE_ZOOM = 15;

function lngLatIn(input: HTMLInputElement): [number, number] | undefined {
  const match = input.value.match(COORDINATES);
  if (!match) return undefined;
  const lat = Number(match[1]);
  const lon = Number(match[2]);
  return Math.abs(lat) <= 90 && Math.abs(lon) <= 180 ? [lon, lat] : undefined;
}

const toMetre = (n: number) => Math.round(n * 1e5) / 1e5;

export function pickLocation(container: HTMLElement) {
  const data = container.dataset;
  const input = document.getElementById(data.input ?? '');
  if (!(input instanceof HTMLInputElement)) return;
  useOwnWorker();

  const start = lngLatIn(input);
  const map = new MapLibreMap({
    container,
    style: data.style ?? '',
    center: start ?? GERMANY,
    zoom: start ? CLOSE_ZOOM : 5,
    cooperativeGestures: true,
    locale: zoomHelp(data),
  });
  map.addControl(new NavigationControl({ showCompass: false }));

  const marker = new Marker({ color: '#c2410c', draggable: true });
  const putMarker = (at: [number, number]) => marker.setLngLat(at).addTo(map);
  const writeInput = ({ lng, lat }: LngLat) => {
    input.value = `${toMetre(lat)}, ${toMetre(lng)}`;
  };
  if (start) putMarker(start);

  map.on('click', (e) => {
    putMarker([e.lngLat.lng, e.lngLat.lat]);
    writeInput(e.lngLat);
  });
  marker.on('dragend', () => writeInput(marker.getLngLat()));
  input.addEventListener('change', () => {
    const at = lngLatIn(input);
    if (!at) return;
    putMarker(at);
    map.easeTo({ center: at, zoom: Math.max(map.getZoom(), CLOSE_ZOOM) });
  });
}
